/**
 * ============================================================
 * SHPE@VT SITE CONFIGURATION
 * ============================================================
 * Edit this file to update site-wide settings, contact info,
 * social media links, donation info, and member portal settings.
 * ============================================================
 */

// ── FEATURE FLAGS ────────────────────────────────────────────
// Set to true when the Members Portal is ready to launch.
// While false, the portal section, the "Members" nav tab, and the
// "Members Portal" login button are all hidden.
export const SHOW_PORTAL = false;

// Set to true when the "What Our Members Say" / "Faces of SHPE@VT" section
// has real quotes and spotlights (see MemberSpotlights.js and SPOTLIGHTS in images.js).
export const SHOW_MEMBER_SPOTLIGHTS = false;

// ── CONTACT & SOCIAL ─────────────────────────────────────────
export const CONTACT = {
  email: 'shpevt@gmail.com',
  address: '3416 Gilbert Place, 220 Gilbert St., Blacksburg, VA 24060',
  instagram: 'https://www.instagram.com/shpe_vt/',
  twitter: 'https://twitter.com/shpe_vt',
  linkedin: 'https://www.linkedin.com/company/society-of-hispanic-professional-engineers/',
  linktr: 'https://linktr.ee/shpe_vt',  // UPDATE if you have a Linktree
};

// ── MEMBERSHIP ───────────────────────────────────────────────
export const MEMBERSHIP = {
  joinUrl: 'https://hokiesync.vt.edu/organization/shpe',  // UPDATE: HokieSync or Hokie Passport link
  dues: 'NONE per semester',  // UPDATE if dues change
  meetingDay: 'Tuesdays at 7:00 PM',  // UPDATE: meeting schedule
  meetingLocation: 'Torgersen Hall 1060',  // UPDATE: meeting location
};

// ── DONATION / SUPPORT ───────────────────────────────────────
// UPDATE: set your Venmo handle and/or PayPal link
export const DONATION = {
  venmoHandle: '@SHPE-VT',           // e.g. '@SHPE-VT' — must start with @
  venmoUrl: 'https://venmo.com/SHPE-VT',  // full Venmo URL
  paypalUrl: '',                      // optional: PayPal.me link
  cashAppUrl: '',                     // optional: Cash App $handle URL
  zelleName: '',                      // optional: Zelle contact info
  suggestedAmounts: [5, 10, 25, 50], // suggested donation amounts shown on site
  campaignDescription: 'Your donation helps fund scholarships, conference travel, and outreach events for SHPE members at Virginia Tech.',
};

// ── MICROSOFT / VT SSO AUTH ──────────────────────────────────
// Members-only portal uses Microsoft OAuth via @vt.edu accounts
export const AUTH = {
  // IMPORTANT: Register your app at https://portal.azure.com
  // Tenant: Virginia Tech's Azure AD (or 'common' if multi-tenant)
  // Required scopes: openid, profile, email, User.Read
  msalClientId: 'YOUR_AZURE_APP_CLIENT_ID',  // REPLACE with your Azure app's Client ID
  msalTenantId: 'vt.edu',                     // or your VT Azure tenant ID
  msalRedirectUri: 'http://localhost:3000',   // UPDATE for production (e.g. https://shpevt.org)
  allowedDomain: 'vt.edu',                    // only @vt.edu emails can access members portal
};

// ── CALENDAR ─────────────────────────────────────────────────
// CalendarSection.js fetches events from every calendar below via the
// Google Calendar API and renders its own event list with filter chips,
// so events can be filtered by committee.
//
// SETUP:
//   1. Get an API key: console.cloud.google.com → APIs & Services →
//      Credentials → Create Credentials → API key. Enable the
//      "Google Calendar API" for the project. Restrict the key to
//      your site's domain (HTTP referrers) once it's live.
//   2. For each committee calendar (owned under shpe581@gmail.com):
//      Calendar settings → "Access permissions" → check
//      "Make available to public" (read-only). Without this the API
//      can't read it, even with a valid key.
//   3. Get each calendar's ID: Calendar settings → "Integrate calendar"
//      → Calendar ID. The main chapter calendar is usually just its
//      email address; calendars created separately look like
//      abc123...@group.calendar.google.com.
export const CALENDAR = {
  apiKey: 'AIzaSyBOgucc6RdEfyDGMN7IepQ4kwmnfNT_r5c',  // UPDATE: get from console.cloud.google.com
  calendars: [
    
    { id: 'shpe581@gmail.com', name: 'General Meetings', color: '#861F41' },
    // Add one entry per committee calendar, e.g.:
     //{ id: 'shpe581@gmail.com', name: 'General Meetings', color: '#861F41' },
    // Add one entry per committee calendar, e.g.:
     { id: 'b7810a300e732eb321403d9032356e619695a3a6f295f20911ecd2152b1a5c51@group.calendar.google.com', name: 'Outreach', color: '#E5751F' },
     { id: 'e21f707544ffd4c6aeac911ac21ba14cf7a9aad15b0b0dcc62891bc2cfe80315@group.calendar.google.com', name: 'SHPEtinas', color: '#B23A6B' },
     { id: 'd55af1a60205ed958b7799db706237d7ebb09e61ee8a8752ba90bc94d8127324@group.calendar.google.com', name: 'MentorSHPE', color: '#1A4A7A' },
     { id: '41bc42ea61b5ceaec45501ccda339ce7e664160d09e0f85655aaf43325f76671@group.calendar.google.com', name: 'GradSHPE', color: '#C8922A' },
  ],
};

// ── NEWSLETTER ───────────────────────────────────────────────
// The signup form submits via Netlify Forms (see components/Newsletter.js
// and the hidden form in public/index.html). The destination email is set
// in the Netlify dashboard, not here — see Site configuration → Forms →
// Form notifications. Point it at shpevt-g@vt.edu (or whoever checks it)
// so they can add new signups to the listserv by hand.

// ── ADMIN / OWNER ACCESS ─────────────────────────────────────
// Owner-only features: editing calendar, posting news, managing scholarships
// Set the emails of people who have admin (owner) access
// These users see the "Admin" badge and can edit calendar events and posts
export const ADMIN_EMAILS = [
  // 'yourname@vt.edu',  // REPLACE with actual admin VT emails
  // 'officer2@vt.edu',
];

// ── FAQ ──────────────────────────────────────────────────────
export const FAQ = [
  {
    question: 'Do I have to be Hispanic to join SHPE?',
    answer: 'Absolutely not! SHPE is open to all students who share our values of community, leadership, and growth. While our organization is rooted in supporting the LatinX community, we welcome everyone.',
  },
  {
    question: 'Do I need to be an engineering major?',
    answer: 'Nope! Students from any major are welcome. We have members in Computer Science, Biology, Business, and many other fields who benefit from our professional development and community.',
  },
  {
    question: 'How much does membership cost?',
    answer: `There are no membership dues unless you plan on going to convention, which then its 10 dollars a year.`,
  },
  {
    question: 'What is SHPE National Convention?',
    answer: 'The SHPE National Convention is an annual conference attended by thousands of Hispanic engineers, students, and recruiters. It\'s one of the best opportunities for networking, career development, and celebrating our community.',
  },
  {
    question: 'How do I prepare for convention?',
    answer: `We run conference prep workshops each semester covering resume reviews, professional attire, interview tips, and what to expect.${SHOW_PORTAL ? ' Check the Members Portal for resources.' : ' Check the calendar for upcoming dates.'}`,
  },
];

// ── PROGRAMS ─────────────────────────────────────────────────
export const PROGRAMS = [
  {
    name: 'GradSHPE',
    icon: '🎓',
    description: 'Supporting graduate students in STEM through research networking, grad school application help, and community.',
    link: '#programs',
  },
  {
    name: 'SHPEtinas',
    icon: '⭐',
    description: 'A sisterhood within SHPE dedicated to empowering Latina women in STEM through mentorship and leadership development.',
    link: '#programs',
  },
  {
    name: 'Outreach',
    icon: '🌱',
    description: 'Inspiring K-12 students through hands-on STEM activities, school visits, and community engagement.',
    link: '#programs',
  },
  {
    name: 'MentorSHPE',
    icon: '🤝',
    description: 'Connecting underclassmen with upperclassmen mentors for academic support, career advice, and guidance.',
    link: '#programs',
  },
];